import { render, staticRenderFns } from "./top-navigation.vue?vue&type=template&id=837b5ac0&scoped=true&"
import script from "./top-navigation.vue?vue&type=script&lang=js&"
export * from "./top-navigation.vue?vue&type=script&lang=js&"
import style0 from "./top-navigation.vue?vue&type=style&index=0&id=837b5ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../production/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837b5ac0",
  null
  
)

export default component.exports